//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionEditAI(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20.43 8.51998L16.92 4.99998L5 16.91V19H7.09L17.6 8.47998L19.02 9.89998L7.91 21H3V16.09L16.92 2.16998L21.85 7.09998L20.43 8.51998Z" fill="currentColor" /><path d="M18.4831 14L19.7639 16.2024L21.9662 17.4831L19.7639 18.7639L18.4831 20.9662L17.2024 18.7639L15 17.4831L17.2024 16.2024L18.4831 14Z" fill="currentColor" /></svg>;
}
export default IconActionEditAI;